import Button from "@/components/base/Button";
import { clinicInfo } from "@/mocks/site";
import { doctors } from "@/data/doctors";

export default function DoctorSpotlight() {
  const doctor = doctors[0];

  return (
    <section id="doctors" className="relative scroll-mt-28 overflow-hidden bg-primary-950 py-16 md:py-24">
      {/* Colourful glows on deep navy */}
      <div className="absolute -left-20 top-0 h-96 w-96 rounded-full bg-primary-500/25 blur-3xl" aria-hidden="true"></div>
      <div className="absolute -right-16 bottom-0 h-96 w-96 rounded-full bg-accent-500/25 blur-3xl" aria-hidden="true"></div>
      <div className="absolute left-1/2 top-1/3 h-72 w-72 rounded-full bg-secondary-500/20 blur-3xl" aria-hidden="true"></div>

      <div className="relative mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 items-center gap-12 lg:grid-cols-12 lg:gap-16">
          <div className="reveal relative lg:col-span-5">
            <div
              className="absolute -left-5 -top-5 bottom-16 w-2/3 rounded-2xl bg-gradient-to-br from-primary-500/30 to-accent-500/30"
              aria-hidden="true"
            ></div>
            <div className="relative overflow-hidden rounded-2xl border border-background-50/15 bg-background-50/5">
              <div className="h-[440px] w-full md:h-[560px]">
                <img
                  src={doctor.image}
                  alt={doctor.imageAlt}
                  title={`${doctor.name} — ${doctor.specialty}, Trichy`}
                  className="h-full w-full object-cover object-top"
                />
              </div>
            </div>
            <div className="absolute -bottom-5 right-3 flex items-center gap-3 rounded-2xl border border-background-50/15 bg-primary-900/85 px-5 py-4 backdrop-blur md:right-6">
              <span className="flex h-11 w-11 flex-none items-center justify-center rounded-md bg-gradient-to-br from-secondary-500 to-primary-500 text-background-50">
                <i className="ri-award-line text-xl" aria-hidden="true"></i>
              </span>
              <span>
                <span className="block font-heading text-sm font-semibold text-background-50">Senior Consultant</span>
                <span className="block font-label text-xs text-secondary-300">Spine Surgeon, SUHAM Hospitals</span>
              </span>
            </div>
          </div>

          <div className="reveal lg:col-span-7">
            <span className="inline-flex items-center gap-2 rounded-full border border-accent-400/40 bg-accent-500/15 px-3 py-1 font-label text-xs font-semibold uppercase tracking-wider text-accent-200">
              Meet Your Specialist
            </span>
            <h2 className="mt-5 font-heading text-3xl font-semibold leading-tight text-background-50 md:text-4xl">
              {doctor.name}
            </h2>
            <p className="mt-2 font-label text-sm font-semibold text-secondary-300">{doctor.designation}</p>

            <p className="mt-5 font-body text-sm leading-relaxed text-background-200 md:text-base">{doctor.bio}</p>

            <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2">
              {doctor.qualification ? (
                <div className="rounded-xl border border-background-50/15 bg-background-50/10 p-5">
                  <p className="font-label text-xs uppercase tracking-wide text-background-300">Qualifications</p>
                  <p className="mt-1.5 font-body text-sm font-medium text-background-50">{doctor.qualification}</p>
                </div>
              ) : null}
              <div
                className={`rounded-xl border border-background-50/15 bg-background-50/10 p-5 ${
                  doctor.qualification ? "" : "sm:col-span-2"
                }`}
              >
                <p className="font-label text-xs uppercase tracking-wide text-background-300">Current position</p>
                <p className="mt-1.5 font-body text-sm font-medium text-background-50">{doctor.affiliation}</p>
              </div>
              <div className="rounded-xl border border-background-50/15 bg-background-50/10 p-5 sm:col-span-2">
                <p className="font-label text-xs uppercase tracking-wide text-background-300">Experience</p>
                <p className="mt-1.5 font-body text-sm font-medium text-background-50">{doctor.experience}</p>
              </div>
            </div>

            <div className="mt-7">
              <p className="font-label text-xs uppercase tracking-wide text-background-300">Areas of expertise</p>
              <div className="mt-3 flex flex-wrap gap-2">
                {doctor.expertise.map((item) => (
                  <span
                    key={item}
                    className="rounded-full border border-secondary-400/40 bg-secondary-500/15 px-3 py-1.5 font-label text-xs font-medium text-secondary-100"
                  >
                    {item}
                  </span>
                ))}
              </div>
            </div>

            <div className="mt-9 flex flex-col gap-3 sm:flex-row">
              <Button to="/about#specialist" variant="light" size="lg" icon="ri-user-line">
                About Your Specialist
              </Button>
              <Button to="/appointment" variant="accent" size="lg" icon="ri-calendar-check-line">
                Book a Consultation
              </Button>
              <a
                href={clinicInfo.phoneHref}
                className="inline-flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-50/20 px-6 py-3 font-label text-base font-semibold text-background-100 transition-colors hover:bg-background-50/10"
              >
                <i className="ri-phone-fill" aria-hidden="true"></i>
                {clinicInfo.phoneDisplay}
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}